<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [class]="[position(), smallSize() ? 'w-14px h-14px' : ''] | joinClassNames">
    <path
        d="M7.7623 21.4876C7.5373 21.4876 7.3498 21.4126 7.1623 21.2626C6.8248 20.9251 6.8248 20.4001 7.1623 20.0626L15.0373 12.0001L7.1623 3.9751C6.8248 3.6376 6.8248 3.1126 7.1623 2.7751C7.4998 2.4376 8.0248 2.4376 8.3623 2.7751L16.8373 11.4001C17.1748 11.7376 17.1748 12.2626 16.8373 12.6001L8.3623 21.2251C8.2123 21.3751 7.9873 21.4876 7.7623 21.4876Z"
        [attr.fill]="color()" />
</svg>
